export default import.meta.ROLLDOWN_FILE_URL_NrG2b_J_6HvlEa0ROyE6jg